import type { Messages } from '@/features/locale/messages'

export type ExploreTab = 'tokens' | 'markets' | 'pools'

export const EXPLORE_TABS: readonly ExploreTab[] = ['tokens', 'markets', 'pools'] as const

export const DEFAULT_EXPLORE_TAB: ExploreTab = 'tokens'

export type ExploreTokenScope = 'catalog' | 'imported' | 'all'

export const EXPLORE_TOKEN_SCOPES: readonly ExploreTokenScope[] = ['catalog', 'imported', 'all'] as const

export function parseExploreTab(value: string | null | undefined): ExploreTab {
  if (value === 'markets' || value === 'pools' || value === 'tokens') return value
  return DEFAULT_EXPLORE_TAB
}

export function buildExplorePath(tab?: ExploreTab): string {
  const resolved = tab ?? DEFAULT_EXPLORE_TAB
  if (resolved === DEFAULT_EXPLORE_TAB) return '/explore'
  return `/explore?tab=${resolved}`
}

export function buildExploreTabLabels(t: Messages): Record<ExploreTab, string> {
  return t.explore.tab
}

export function buildExploreSearchEmptyCopy(t: Messages) {
  return {
    clearSearch: t.explore.search.clear,
    tokens: t.explore.search.tokens,
    markets: t.explore.search.markets,
  }
}

export function buildExploreTokenScopeLabels(t: Messages): Record<ExploreTokenScope, string> {
  return t.explore.tokenScope
}

export function buildExploreTokenCopy(t: Messages) {
  return t.explore.token
}

export function buildExploreConfig(t: Messages) {
  return {
    tabLabels: buildExploreTabLabels(t),
    searchEmptyCopy: buildExploreSearchEmptyCopy(t),
    tokenScopeLabels: buildExploreTokenScopeLabels(t),
    tokenCopy: buildExploreTokenCopy(t),
  }
}
